import { put, race, take } from 'redux-saga/effects';

import { ACTION_TYPES, detailsSettingsModal } from './actions';

export function* detailsSettingsModalFlow(
  param: Parameters<typeof detailsSettingsModal.open>[0],
) {
  yield put(detailsSettingsModal.open(param));

  const { confirm } = yield race({
    confirm: take(ACTION_TYPES.detailsSettingsModalConfirm),
    close: take(ACTION_TYPES.detailsSettingsModalClose),
  });

  if (confirm) {
    return confirm.payload;
  } else {
    return null;
  }
}
